// Utility to clear all caches and force reload
export async function clearAllCachesAndReload() {
  console.log('[XORA] Clearing all caches...');
  
  // Clear Service Worker caches
  if ('caches' in window) {
    const cacheNames = await caches.keys();
    await Promise.all(
      cacheNames.map(cacheName => {
        console.log(`[XORA] Deleting cache: ${cacheName}`);
        return caches.delete(cacheName);
      })
    );
  }
  
  // Unregister all service workers
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(
      registrations.map(registration => {
        console.log('[XORA] Unregistering service worker');
        return registration.unregister();
      })
    );
  }
  
  // Clear local storage
  localStorage.clear();
  sessionStorage.clear();
  
  // Force reload without cache
  window.location.reload();
}

// Make it available globally for debugging
(window as any).clearXoraCache = clearAllCachesAndReload;